// src/components/CreateSpace/Step2/components/AreaSection.jsx

import React from "react";
import { NumberInput, MessageBox } from "reusableComponents";
import { getDispositionTypes } from "helpers/getSpaceDispositionTypes";
import styles from "./styles.module.scss";
import typographyStyles from "../../styles/_typography.module.scss";

export const AreaSection = ({ 
  formValues, 
  fieldErrors, 
  handleInputChange, 
  requiresDispositionTypes,
  t 
}) => {
  const allDispositionTypes = getDispositionTypes(t);
  
  // Filter disposition types based on space type
  const getFilteredDispositionTypes = () => {
    const placeUsageKey = formValues?.placeUsage?.key;
    const isMeetingRoom = placeUsageKey === "meeting_room";
    
    if (isMeetingRoom) {
      // For meeting rooms, exclude cabaret (key "6") and banquet (key "7")
      return allDispositionTypes.filter(type => type.key !== "6" && type.key !== "7");
    }
    
    // For all other space types, return all disposition types
    return allDispositionTypes;
  };
  
  const dispositionTypes = getFilteredDispositionTypes();

  return (
    <div className={styles.section}>
      <h4 className={typographyStyles.subtitle}>{t("provide.step2.area.title")}</h4>
      
      <div className={styles.sizeInputsContainer}>
        <NumberInput
          labelAbove
          required
          label={t("provide.step2.area.area")}
          name="area"
          value={formValues.area}
          onChange={(e) => handleInputChange("area", e.target.value)}
          addonText={t("provide.step2.area.unity")}
          error={fieldErrors.area}
          data-error={!!fieldErrors.area}
        />
        
        {/* Private Office & Shared Office */}
        {(formValues?.placeUsage?.key === "private_office" || 
          formValues?.placeUsage?.key === "shared_office") && (
          <NumberInput
            labelAbove
            required
            label={t("provide.step2.area.workPlaces")}
            name="desk"
            value={formValues.desk}
            onChange={(e) => handleInputChange("desk", e.target.value)}
            addonText={t("provide.step2.area.places")}
            error={fieldErrors.desk}
            data-error={!!fieldErrors.desk}
          />
        )}
        
        {/* Coworking Space */}
        {formValues.placeUsage?.key === "coworking" && (
          <>
            <NumberInput
              labelAbove
              required
              label={t("provide.step2.area.numbercoworkingstationtotal")}
              name="desk"
              value={formValues.desk}
              onChange={(e) => handleInputChange("desk", e.target.value)}
              addonText={t("provide.step2.area.places")}
              error={fieldErrors.desk}
              data-error={!!fieldErrors.desk}
            />
            <NumberInput
              labelAbove
              required
              label={t("provide.step2.area.workPlacesPerBooking")}
              name="coworking_stations"
              value={formValues.coworking_stations}
              onChange={(e) => handleInputChange("coworking_stations", e.target.value)}
              addonText={t("provide.step2.area.places")}
              error={fieldErrors.coworking_stations}
              data-error={!!fieldErrors.coworking_stations}
            />
          </>
        )}
      </div>

      {/* Disposition Types Section */}
      {requiresDispositionTypes(formValues.placeUsage?.key) && (
        <>
          <MessageBox type="info" message={t("provide.step2.area.help")} />
          
          {/* Display general disposition types error if it exists */}
          {fieldErrors.dispositionTypes && (
            <div className={styles.dispositionError}>
              <MessageBox 
                type="error" 
                message={fieldErrors.dispositionTypes} 
              />
            </div>
          )}
          
          <div className={styles.dispositionTypesList}>
            {dispositionTypes.map((type) => (
              <div key={type.key} className={styles.dispositionItem}>
                <div className={styles.iconContainer}>
                  <type.Icon />
                </div>
                <div className={styles.inputContainer}>
                  <NumberInput
                    labelAbove
                    label={type.name}
                    name={type.key2}
                    value={formValues[type.key2]}
                    min={0}
                    max={1000}
                    onChange={(e) => handleInputChange(type.key2, e.target.value)}
                    addonText={t("provide.step2.area.people")}
                    error={fieldErrors[type.key2]}
                    data-error={!!fieldErrors[type.key2]}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AreaSection;